import { render, staticRenderFns } from "./in--code.vue?vue&type=template&id=2fcd4024&"
import script from "./in--code.vue?vue&type=script&lang=js&"
export * from "./in--code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports